<script lang="ts">
      import { browser } from '$app/environment'
      import ImageElement from '$lib/components/gallery/ImageElement.svelte'
      import VideoElement from '$lib/components/video/BackdropVideoElement.svelte'
      import { delay } from '$lib/utils/flip'
      import { Result } from '$lib/utils/result'
      import { onMount, tick } from 'svelte'

      let glassdrop: HTMLDivElement | null = null
      let container: HTMLDivElement

      function isVideo(mimeType: string) {
            return mimeType.match('video/')
      }

      function isImage(mimeType: string) {
            return mimeType.match('image/')
      }

      function isType(mimeType: string) {
            if (!mimeType) return undefined
            if (isImage(mimeType)) return 'image'
            if (isVideo(mimeType)) return 'video'
            return undefined
      }

      async function playVideos() {
            //  await new Promise( r => setTimeout(() => r(true), 1500))
            if (video && videoBlur) {
                  const load = await Promise.allSettled([video.loadAsync(), videoBlur.loadAsync()])
                  //await delay(5000)

                  //video.showVideo()
                  //videoBlur.showVideo()
                  //console.log('loaded')
                  const play = await Promise.allSettled([video.playAsync(), videoBlur.playAsync()])

                  autoplayAbort.abort()
                  //console.log('ended')
                  if (loop) setTimeout(playVideos, 2000)
            }
      }

      function videoFallback(video) {
            const _video = video
            const ct = new AbortController()
            document.addEventListener(
                  'touchstart',
                  () => {
                        if (_video.isPlaying()) return ct.abort()
                        console.log('fallback')
                        playVideos()
                        ct.abort()
                  },
                  {
                        signal: ct.signal,
                  }
            )
      }

      async function checkIfPlaying() {
            console.log('checking')
            if (!video) return
            console.log(video.isPlaying())
            if (video.isPlaying()) return
            playVideos()
            autoplayAbort.abort()
      }

      let autoplayAbort: AbortController

      async function loadAssets(container: HTMLElement) {
            if (!browser) return
            if (!backdrop?.url || !backdropBlur?.url) return

            await tick()
            playVideos()

            autoplayAbort = new AbortController()
            document.documentElement.addEventListener('touchstart', checkIfPlaying, { once: true, signal: autoplayAbort.signal })
            document.documentElement.addEventListener('scroll', checkIfPlaying, { once: true, signal: autoplayAbort.signal })
            document.documentElement.addEventListener('click', checkIfPlaying, { once: true, signal: autoplayAbort.signal })
      }

      onMount(() => {
            setTimeout(() => Result(() => loadAssets(container)), 0)
      })

      //let loaded: boolean = $state(false)

      let video: VideoElement
      let videoBlur: VideoElement

      let { blur, children = null, backdrop, backdropBlur, loop = false } = $props()
</script>

<div bind:this={container} class="w-full sticky top-0 -z-10">
      <div class="w-full h-screen absolute top-0 flex items-center">
            <div bind:this={glassdrop} style="--blurOpacity: {blur}" class="glassdrop absolute h-full w-full flex items-center justify-center top-0 left-0 z-10">
                  <!--{#if loaded == true}-->
                  {#if isType(backdropBlur?.mimeType) == 'video'}
                        <VideoElement bind:this={videoBlur} video='/after28/portrait.mp4_noaudio_blur.mp4' cache={true}></VideoElement>
                        <!--<VideoElement bind:this={videoBlur} video={backdropBlur.url} cache={true}></VideoElement>-->
                  {:else if isType(backdropBlur?.mimeType) == 'image'}
                        <img src={backdropBlur.url} alt={backdropBlur.alt} class="w-full h-full object-cover" />
                  {/if}
                  <img src="/after28/portrait.mp4_noaudio_blur.webp" alt="df28" class="w-full h-auto  object-contain absolute z-[-1]" />
                  <!--{/if}-->
            </div>
            <!--{#if loaded == true}-->
            <div class="w-full h-auto flex items-center justify-center">

                  {#if isType(backdrop?.mimeType) == 'video'}
                  <VideoElement bind:this={video} video="/after28/portrait.mp4_noaudio.mp4" cache={true}></VideoElement>
                  <!--<VideoElement bind:this={video} video={backdrop.url} cache={true}></VideoElement>-->
                  {:else if isType(backdrop?.mimeType) == 'image'}
                  <img src={backdrop.url} alt={backdrop.alt} class="w-full h-full object-cover" />
                  {/if}
                  <img src="/after28/portrait.mp4_noaudio.webp" alt="df28" class="w-full h-auto object-contain absolute z-[-1]" />
            </div>
            <!--{/if}-->
            <!--<div class="absolute top-0 bg-red-400 w-full h-full"></div>-->
      </div>
</div>
{@render children?.()}

<style>
      .glassdrop {
            /*@apply bg-pink-700;*/
            /*backdrop-filter: blur(30px);*/
            transition: opacity 0.7s ease-in-out;
            opacity: var(--blurOpacity);
            background-color: #ffffff33;
      }
</style>
